
import RadioInput from '@/components/ui/RadioInput.vue'
import ButtonDefault from '@/components/ui/ButtonDefault.vue'
import FormTextInput from '@/components/ui/FormTextInput.vue'
import MultiSelect from '@/components/ui/MultiSelect.vue'
import InputError from '@/components/ui/InputError.vue'
import { CreditData } from '@/config/variables'
import { defineComponent, ref, watch } from 'vue-demi'
import { theme } from '@/config/styles'

/**
 * Component utilizado na primeira etapa da solicitação de crédito
 * @props {String} limit - Limite de crédito
 * @props {String} installment - Parcelas para a solicitação
 * @emits nextStepClicked - utilizado para fazer a mudança de etapas do form
 * @emits valueChanged - utilizado para fazer a mudança dos valores do 
 * limits e installment
 */
export default defineComponent({
    props: {
        limit: [String, Number],
        installment: [String, Number],
    },
    emits: ['nextStepClicked', 'valueChanged'],
    components: {
        RadioInput,
        ButtonDefault,
        FormTextInput,
        MultiSelect,
        InputError,
    },
    setup(props, context) {
        const creditData = CreditData
        const lenghReason = creditData.text.listReasons.length
        const reason = ref('')
        const reasonOthers = ref('')
        const others = creditData.text.listReasons[lenghReason - 1]
        const isInvalid = ref(false)

        /**
         * Função utilizada para limpar o campo do motivo no form
         */
        const reset = (): void => {
            reasonOthers.value = ''
            isInvalid.value = false
        }
        /** Função para validar o multiselect */
        const handleReasonSelect = (): void => {
            if (reason.value == '' || reason.value == undefined)
                isInvalid.value = true
            else isInvalid.value = false
        }
        /** Função utilizada para validar o input de outro motivos */
        const validationReasonOthers = (): void => {
            handleReasonSelect()
            if (reason.value == others)
                if (reasonOthers.value == '' || reasonOthers.value.length < 10)
                    isInvalid.value = true
                else isInvalid.value = false
        }
        /**
         * Função utilizada para emitir um evendo
         * quando o botão continuar é clicado
         * Não faz nada caso um dos inputs obrigátorio seja inválido
         */
        const nextStepClicked = (): void => {
            validationReasonOthers()
            if (isInvalid.value == true) return
            if (reason.value === others)
                context.emit('nextStepClicked', reasonOthers.value, reset)
            else context.emit('nextStepClicked', reason.value, reset)
        }

        /** Este evento é acionado sempre que o multiselect é clicado.*/
        watch(reason, () => handleReasonSelect())
        /** No momento que o radio input e clicado, handle input triggers */
        const handleInput = (
            limit: string | null,
            installment: string | null
        ): void => {
            context.emit('valueChanged', limit, installment)
        }
        return {
            creditData,
            reason,
            others,
            reasonOthers,
            isInvalid,
            nextStepClicked,
            handleInput,
            theme
        }
    },
})
